"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLocation = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M64.34 43.25a1.6 1.6 0 0 0-1.47-1H41.81c3.55-6.78 7.47-15.24 7.47-19.45a14.31 14.31 0 1 0-28.62 0c0 4.22 3.93 12.67 7.47 19.45h-5.57a1.6 1.6 0 0 0-1.17.51L7 58.15a1.6 1.6 0 0 0 1.17 2.69h40.3a1.6 1.6 0 0 0 1.17-.51L64 45a1.6 1.6 0 0 0 .34-1.75zM46.09 22.84C46.09 27.62 39 41 35 48.11c-4-7.07-11.11-20.49-11.11-25.27a11.11 11.11 0 0 1 22.22 0zm1.69 34.81H11.86l11.4-12.15h6.59c1.83 3.36 3.33 5.9 3.75 6.62a1.6 1.6 0 0 0 2.75 0c.43-.72 1.92-3.27 3.75-6.62h19.08z"
  }), _react["default"].createElement("path", {
    d: "M35 29.68a7.46 7.46 0 1 0-7.46-7.46A7.47 7.47 0 0 0 35 29.68zm4.26-7.46A4.26 4.26 0 1 1 35 18a4.27 4.27 0 0 1 4.24 4.21zM28.71 49.31a9.22 9.22 0 0 0-3.58.38 1.6 1.6 0 1 0 1 3.05 6 6 0 0 1 2.35-.24 1.6 1.6 0 1 0 .27-3.19zM20.39 52.11l-2.61 1.47a1.6 1.6 0 0 0 1.57 2.79L22 54.9a1.6 1.6 0 0 0-1.57-2.79zM48.7 51.92a1.59 1.59 0 0 0 .75-.19l2.65-1.42a1.6 1.6 0 1 0-1.51-2.82l-2.65 1.42a1.6 1.6 0 0 0 .76 3zM39.63 53.32a1.6 1.6 0 0 0 1.57 1.32h.29a24.54 24.54 0 0 0 3.11-.79 1.6 1.6 0 0 0-1-3 21.38 21.38 0 0 1-2.7.68 1.6 1.6 0 0 0-1.27 1.79z"
  })),
  height: undefined,
  width: undefined
});
IconLocation.displayName = 'IconLocation';
var _default = IconLocation;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/location.js
// module id = 579
// module chunks = 0